import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'TAI CHI WALKING <br/> FOR BEGINNERS',
			size: 'large',
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: 'Based on your <b>age</b>',
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: require('@/assets/landing/welcome-for-google-tai-chi-walking/tai-chi-walking-welcome.webp'),
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
